import React, { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { useI18n } from "@/i18n/I18nContext";

export default function Marquee() {
  const { t } = useI18n();
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({
    target: ref,
    offset: ["start end", "end start"],
  });
  const x = useTransform(scrollYProgress, [0, 1], ["0%", "-15%"]);
  const phrases = t.marquee;

  return (
    <section
      ref={ref}
      className="relative overflow-hidden py-8 md:py-10 border-y border-[rgba(15,31,23,0.12)]"
      style={{ background: "var(--marigold)" }}
      data-testid="marquee-section"
    >
      <motion.div
        style={{ x }}
        className="flex whitespace-nowrap gap-8 md:gap-14"
      >
        <div className="flex marquee-track whitespace-nowrap gap-8 md:gap-14">
          {[...phrases, ...phrases, ...phrases].map((p, i) => (
            <div key={i} className="flex items-center gap-8 md:gap-14 shrink-0">
              <span
                className="font-display text-[2.4rem] md:text-[4.5rem] leading-none tracking-tight font-medium"
                style={{
                  WebkitTextStroke: i % 2 === 1 ? "1.5px var(--cream)" : "none",
                  color: i % 2 === 1 ? "transparent" : "var(--cream)",
                }}
              >
                {p}
              </span>
              <span className="text-[var(--cream)] text-4xl md:text-6xl opacity-80">✦</span>
            </div>
          ))}
        </div>
      </motion.div>
    </section>
  );
}
